import ajax from './ajax';
import { toast } from './toast';
import { clearToast } from './toast';
import { getMultiLang } from './getMultiLang';
import ReactDOM from 'react-dom';
import CONFIG from './config';
import { getAppUrl, setAppUrl, getOrigin, getUrlKey } from './appUrlUtils';
import { getCookie, setCookie } from './cookie';
import { getSafeRandom, isObject } from './utils';
import { getGlobalStorage } from './storage';
import { getParentWindow, getTopWindow, getLocation, getMainWindow } from './window.js';
import ViewModel from './viewmodel';
import { getLangCode } from './currentLocale';
import { getMicroHistory, getMicroLocation, getMicroHref, getMicroContext, isQiankunEnv, getRunContext } from './qiankunContext';
import Gzip from './gzip';
const gziptools = new Gzip();
//所有url参数的修改，需要同步到window的runContext.appInfo上
//createpage里面的window是对的，但pageTo上的window不对是顶层

/**
 * Url为目标跳转节点的资源路径，pushTo只需要传路由路径，如'/card'; <br/> openTo或者linkTo为完整地址，如采购订单 '/pu/pu/poorder/main/index.html'
 * @memberof PageTo
 * @typedef Url
 */

/**
 * ParentParams 给父window窗口设置参数, 作为业务扩展系统参数custom; ajax请求时传给后台，openTo打开页签时，会携着该参数跳转，共享的集团信息需求
 * @memberof PageTo
 * @typedef ParentParams
 */

/**
 * Params 为url参数对象，值类型为Object, 格式为 { key1: value1, key2:value2 }: 
 * @memberof PageTo
 * @typedef Params
 */

/**
 * ContextData参数说明
 * @memberof PageTo
 * @typedef ContextData
 * @property {string} appcode 应用编码
 * @property {string} pagecode 页面编码
 * @property {string} appname 应用名称
 * @property {string} appid 应用id
 * @property {string} field 领域名
 * @property {string} module 模块名
 * @property {string} menuclass 菜单分类
 * @property {string} menu 菜单名称
*/

/**
 * OtherConfig参数说明
 * @memberof PageTo
 * @typedef OtherConfig
 * @property {boolean} uniqueTab=false 是否页签去重, 打开新页签时有效
 * @property {boolean} isAddNCCPrefixPath=true 生产环境page是否自动加前缀'nccloud/resources/'
 * @property {string | array | Object | boolean} crossTabData 跨页签通信数据,打开新页签时有效
 * @property {boolean} paramInUrl=false 跳转参数是否放地址栏(刷新不丢失)，默认是false,刷新丢失
*/

/**
 * BillInfo参数说明
 * @memberof PageTo
 * @typedef BillInfo
 * @property {string} billpk 联查页面的单据pk
 * @property {string} billtype 联查页面的单据类型
 * @property {string} type=link '前页签打开link'/'新页签打开open'
*/

const contextKeyMap = {
    appcode: 'c',
    pagecode: 'p',
    appname: 'n',
    appid: 'ar',
    field: 'b1',
    module: 'b2',
    menuclass: 'b3',
    menu: 'b4',
    //fifthmenu: 'b5',
};

// // 判断浏览器是否为IE
// const isIE = (
//     navigator.userAgent.indexOf("MSIE")!=-1 || !!window.ActiveXObject || "ActiveXObject" in window
// )

// self===top true 说明是顶层

/**
 * 跳转检查 （ 占用 license ）
 * 调用此方法去修改URL地址时需要encodeURIComponent两次
 * 获取URL参数时需要decodeURIComponent两次
 * @param {string} appcode - 应用编码 值为""/undefined/null 则不会校验权限  需要工作台容器
 * @param {string} pagecode - 页面编码编码 值为""/undefined/null 则返回应用默认页面
 * @param {function} callback - 检查之后的回调
 * @param {string} tab - 新页签
 */
function topOpenCheck(appcode, pagecode, callback, type) {
    let win = window;
    let cckk = (getTopWindow() && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
    // 做一次 数据转型
    cckk = isNaN(cckk) ? cckk : Number(cckk);
    setCookie('cookiets', cckk);
    getTopWindow() && (getTopWindow().cookiets = cckk);
    // 需要校验权限
    if (appcode && appcode.length) {
        window.actionName = '权限校验';
        ajax({
            url: `/nccloud/platform/appregister/openapp.do`,
            data: {
                appcode,
                pagecode,
            },
            sysAppcode: 10228888,
            async: false,
            success: ({ data }) => {
                callback(win, { data: data }, newUrl => {
                    if (type === "tab" && newUrl) {
                        openNewTabs(newUrl);
                    }
                });
                win = null;
            },
        });
    } else {
        // 不需要校验跳转权限且需要工作台容器
        /**
         * 校验回调
         * @param {Object} win - 窗口对象
         */
        callback(win);
        win = null;
    }
}

/**
 * 跳转检查 （不占用 license）
 * 参数及注意 同 window.openCheck 方法
 */
function topSpecialOpenCheck(appcode, pagecode, callback, type) {
    let win = window;
    // 需要校验权限
    if (appcode && appcode.length) {
        window.actionName = '权限校验';
        ajax({
            url: `/nccloud/platform/appregister/openapp2.do`,
            data: {
                appcode,
                pagecode,
            },
            sysAppcode: 10228888,
            async: false,
            success: ({ data }) => {
                callback(win, { data: data }, newUrl => {
                    if (type === "tab" && newUrl) {
                        //window.open(newUrl, "_blank");
                        openNewTabs(newUrl);
                    }
                });
                win = null;
            },
        });
    } else {
        // 不需要校验跳转权限且需要工作台容器
        /**
         * 校验回调
         * @param {Object} win - 窗口对象
         */
        callback(win);
        win = null;
    }
}

function openNewTabs(newUrl) {
    if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
        let a = document.createElement('a');
        a.setAttribute('href', newUrl);
        a.setAttribute('target', '_blank');
        a.setAttribute('id', 'hiddenOpenToElement');
        a.setAttribute('hidden', true);
        // 防止反复添加
        if (document.getElementById('hiddenOpenToElement')) {
            document.body.removeChild(document.getElementById('hiddenOpenToElement'));
        }
        document.body.appendChild(a);
        a.click();
    } else {
        window.open(newUrl, "_blank");
    }
}

function _encode(param) {
    return encodeURIComponent(encodeURIComponent(param));
}

function _decode(param) {
    return decodeURIComponent(decodeURIComponent(param));
}

function getBreadCrumb(appInfo, appName, params = {}) {
    let result = '';
    let mergeAppInfo = Object.assign({}, params, appInfo);
    let { menu, menuclass, module, field, fifthmenu } = mergeAppInfo;
    let bcList = [field, module, menuclass, menu]; //领域/模块/应用分组/应用
    //个别领域有五级菜单 需要区分四级菜单和五级菜单
    if (fifthmenu) {
        bcList = [...bcList, fifthmenu]; //领域/子领域/模块/应用分组/应用
    }
    bcList.forEach((item, i, arr) => {
        let key = '';
        if (i === arr.length - 1) {
            key = 'n';//末级是n，其他层级为b1/b2/b3/b4
            item = appName || item;
        } else {
            key = `b${i + 1}`;
        }
        result += `&${key}=${encodeURIComponent(encodeURIComponent(item))}`; //两次转义
    });
    return result;
}

// 获取旧工作台给小友机器人用的 param 参数
function _getWorkbenchParam(oldWinHash, type) {
    let paramVal = '';
    let oldParams = '';

    let openNoParamFlag = !oldWinHash.includes('ifr=') && (type === "open" || type === "link");
    // openTo 场景下，若无 ifr 参数，直接根据返回参数打开
    if (oldWinHash.includes('?') && !openNoParamFlag) {
        oldParams = oldWinHash.split('?')[1];
    }
    let paramArr = oldParams.split('&');
    if (paramArr.length) {
        let item = paramArr.find(e => e.includes('param='));
        if (item) {
            paramVal = _decode(item.split('=')[1]);
        }
    }
    return paramVal;
}

//分离出url
function _getResPageUrl(pageurl, params = {}) {
    //业务url参数格式问题
    for (let pop in params) {
        if (typeof params[pop] === "string" && (params[pop].includes('#') || params[pop].includes('?'))) {
            params[pop] = _encode(params[pop]);
        }
    }
    let [newPage, newHash = ''] = pageurl.split('#');
    let urlParm = '';
    if (newHash.includes('?')) { //原来有业务参数
        urlParm = newHash.split('?')[1];
        newPage = newPage + '#' + newHash.split('?')[0];
    } else {//原来没有业务参数
        newPage = newPage + '#' + newHash;
    }
    let getHashVals = '';
    if (urlParm) {
        let paramsVal = urlParm.split('&');
        if (paramsVal && paramsVal instanceof Array && paramsVal.length > 0) {
            //已存在的参数更新
            let hashArr = [];
            let hasItemFlag = {};
            hashArr = paramsVal.map(elem => {
                if (elem.indexOf('=') != -1 && elem.split('=') && elem.split('=') instanceof Array) {
                    if (params && params[elem.split('=')[0]]) {
                        hasItemFlag[`${elem.split('=')[0]}`] = true;
                        elem = `${elem.split('=')[0]}=${params[elem.split('=')[0]]}`;
                    }
                }
                return elem;
            });
            //不存在的参数新增
            for (let pop in params) {
                if (!hasItemFlag[pop]) {
                    hashArr.push(`${pop}=${params[pop]}`);
                }
            }
            getHashVals = hashArr.join('&');
        }
    } else {
        getHashVals = getHashValue(params, true);
    }
    let newPath = '';
    if (newPage.includes("#")) {
        newPath = addNCCPrefix(newPage) + (getHashVals ? '?' + getHashVals : '');
    } else {
        newPath = addNCCPrefix(newPage) + (getHashVals ? '#/?' + getHashVals : '');
    }
    return newPath;
}

//校验回调
function checkCallBack(configParams) {
    let {
        win, //打开页签window
        res, //后台返回应用信息
        path, // 业务传递url
        appcode,
        pagecode,
        type, //打开方式 'open' 'link' 'router'
        oldWinHash, //原来的参数
        params = {}, //业务传新参数
        onChangeRouter = null, //打开页面后的回调
        parentParam = null, //业务传给父window参数  作为上下文参数，传给ajax系统参数使用，如 共享的 custom
        openWinCallBack,
        uniqueTab = false, //页签去重
        runContext,
        pushToSuccess,
    } = configParams;
    let resParam = res.data;

    if (resParam) {
        let metacode = pagecode || resParam.pagecode;
        //四级菜单：b1/b2/b3/n
        //五级菜单：b1/b2/b3/b4/n
        let newParams = {
            ifr: path || _getResPageUrl(resParam.pageurl, params),
            //b1: resParam.field,
            //b2: resParam.module,
            //b3: resParam.menuclass,
            //b4: resParam.menu,
            // 没有is_sec_develop不要设置成 'N'
            // sec_develop: resParam.is_sec_develop ? 'Y' : 'N',
            c: appcode,
            ar: resParam.appid,
            p: metacode,
            lang: getLangCode(),
            //n: params.nccloud_menu_name_self || resParam.fifthmenu || resParam.getHashValuemenu,
        };

        if (resParam.is_sec_develop) {
            newParams.sec_develop = 'Y';
        }

        //跳转导致workbench给小友机器的参数跳转页面
        let paramVal = _getWorkbenchParam(oldWinHash, type);
        if (paramVal) {
            newParams.param = paramVal;
        }

        if (parentParam && Object.prototype.toString.call(parentParam) === "[object Object]") {
            let custom = getSearchParam("custom", { runContext: runContext });
            custom = JSON.stringify(parentParam);
            newParams.custom = custom;
        }
        // if(type === 'router'){
        //     //同步ifr和pagecode到runContext.appInfo
        //     // if(typeof pushToSuccess == "function"){
        //     //     pushToSuccess(newParams);
        //     // }else{
        //     // syncRunContext(newParams);
        //     //} 
        //     syncUrlKeyStorage(newParams);
        // }
        let breadCrumbParam = getBreadCrumb(resParam, params.nccloud_menu_name_self, params);
        let newParam = getHashValue(newParams, true) + breadCrumbParam;
        if (win) {
            let windowTabId = randomNumber();
            if (uniqueTab && type === 'open') {
                windowTabId = `${appcode}-${metacode}`;
            }
            let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
            if (type === 'link' || type === 'router') {
                // if (type === 'router') { // pushTo情况下 不修改top的 page参数
                //     // 解决： 先打开列表 后跳转到卡片 ，此时再点菜单自动定位到该应用 但page变成了列表的，导致业务在卡片界面获取的url参数是列表的
                //     windowTabId = getPageId(true); //pushTo不能更新地址
                // }
                //  YBP-RIA-BUG-7396   :   pushTo 和 linkTo urlkey不变，只改sessionStorage和 window.location
                windowTabId = getPageId(true);
                //linkTo更新新的地址 html变化的话，必须要更了top的hash 不然 workbench中iframe的src会被销毁
                if (isInsideTab || (win === getTopWindow() && CONFIG.isPageModal)) {
                    if (isInsideTab) {
                        // if(type === 'link'){
                        //     openWinCallBack(`#/?page=${windowTabId}`, { tabKey: getUrlKey() }); //YBP-RIA-BUG-7174
                        // }else{
                        //     getTopWindow().location.hash = `#/?page=${windowTabId}`; //更新top的hash
                        // }
                        //不能调用openWinCallBack因为会产生新的iframe影响自动化测试 YBP-CCF-BUG-2122
                        if (type === 'link') {
                            const tabKey = getUrlKey();
                            // 通过上下文来看，windowTabId实际上获取到的是顶部url地址上的key
                            // 这个key会跟随当前激活的页签
                            if (windowTabId !== tabKey) { // 跳转时当前页签已经不处于激活状态 YBP-CCF-BUG-2899
                                windowTabId = tabKey;
                            }
                        } else {
                            //如果是业务节点内部又使用iframe嵌套了单据 单据内部使用了pushTo这里需要修改 YBP-CCF-BUG-3287
                            if(getParentWindow(window) == getTopWindow()){
                                getTopWindow().location.hash = `#/?page=${windowTabId}`; //更新top的hash
                            }
                        }
                    } else {//浏览器页签更新top
                        getTopWindow().location.hash = `#/ifr?page=${windowTabId}`;//更新top的hash
                    }
                    setAppUrl(windowTabId, newParam);
                }
                else {
                    win.location.hash = `#/ifr?${newParam}`;
                }

                if (typeof onChangeRouter === 'function') {
                    onChangeRouter(newParams, windowTabId);
                }

                setTimeout(() => {
                    updateBreadcrumb();//解决问题NCC-125336  pushTo由于未修改 page参数，工作台无法监听，因此无法更新面包屑导航
                }, 0);

                // //linkTo模式，若是内部页签模式，需要回调工作台,工作台内部load新的微应用
                // if(type === 'link'){
                //     getLocation(window).href = newParams.ifr;
                // }
            } else {
                if (CONFIG.isPageModal) {
                    let newPage = `#/ifr?page=${windowTabId}`;
                    if (CONFIG.isRemoveWorkbench) {
                        newParam = resParam.pageurl + '#/?' + newParam;
                        newPage = `${resParam.pageurl}#/?page=${windowTabId}`;
                    }
                    setAppUrl(windowTabId, newParam);
                    openWinCallBack(newPage);
                } else {
                    let newPage = `#/ifr?${newParam}`;
                    if (CONFIG.isRemoveWorkbench) {
                        newPage = `${resParam.pageurl}#/?${newParam}`;
                    }
                    openWinCallBack(newPage);
                }
            }
        } else {
            let getJsonCallback = json => {
                toast({
                    color: 'warning',
                    title: json["api-app-pageTo-0001"],
                    content: json["api-app-pageTo-0002"],
                });
            };
            getMultiLang({ moduleId: "api_app_pageTo", callback: getJsonCallback });
        }
    }
}

function isInsideTab() {
    let mode = JSON.parse(sessionStorage.getItem('start-tab'));
    if (mode) {
        return true;
    }
    return false;
}

// 处理 linkTo 场景下：用户点了浏览器后退后，再点linkTo跳转详情界面，详情不更新的问题
// 点浏览器后退，只回退了 iframe 未回退主页面的history;
// function backLink(topUrl, currentUrl, newPage) {
//     if (newPage) {
//         if (newPage.includes("#")) { newPage = newPage.split("#")[0]; }
//         if (newPage.includes("?")) { newPage = newPage.split("?")[0]; }
//     }
//     topUrl = _decode(topUrl);
//     if (topUrl.includes(newPage) && !currentUrl.includes(newPage)) {
//         getTopWindow().location.reload();
//     }
// }

/**
 * @namespace PageTo
*/

/**
 * 在当前页签打开节点
 * @memberof PageTo
 * @param {Url} page 跳转url
 * @param {Params} params 跳转参数, 参数格式为：{ key1: value1, key2: value2 }
 * @param {function} onHashChange hash值改变的回调
 */
function linkTo(page, params, onHashChange, othersConfig = {}) {
    clearToast();
    to({ ...othersConfig, page, params, type: 'link', onHashChange });
}

/**
 * 以新页签方式打开节点
 * @memberof PageTo
 * @param {Url} page 跳转url
 * @param {Params} params 跳转参数, 参数格式为：{ key1: value1, key2: value2 }
 * @param {ParentParams} parentParam 跳转往window上加参数 ,作为上下文参数，传给ajax系统参数使用，如 共享的 custom
 * @param {OtherConfig} othersConfig 其他参数, uniqueTab:是否页签去重, 默认是false; <br/> isAddNCCPrefixPath:生产环境page是否自动加前缀'nccloud/resources/', 默认是true;<br/> crossTabData: 跨页签通信数据
 */
function openTo(page, params = {}, parentParam, othersConfig = {}) {
    let { _crossTabData, ...others } = params;
    let { uniqueTab = false, isAddNCCPrefixPath = true, openCheck = true, crossTabData } = othersConfig;
    if (page && (page.substring(0, 7) === '/ncchr/' || page.substring(0, 6) === 'ncchr/')) {
        isAddNCCPrefixPath = false;
    }
    to({
        ...othersConfig,
        page,
        params: others,
        type: 'open',
        parentParam,
        uniqueTab,
        isAddNCCPrefixPath,
        crossTabData: crossTabData || _crossTabData, //兼容之前参数在第四个
        openCheck,
    });

}

/**
 * 单页路由下，跳转到指定路由页面
 * @memberof PageTo
 * @param {Url} page 跳转url
 * @param {Params} params 跳转参数
 * @param {function} onHashChange hash值改变的回调
 * @param {OtherConfig} othersConfig 其他参数， paramInUrl：跳转参数是否放地址栏(刷新不丢失)，默认是false,刷新丢失
 */
function pushTo(page, params, onHashChange, othersConfig = {}) {
    let { paramInUrl = false } = othersConfig;
    clearToast();
    if (!paramInUrl) {
        ViewModel.setData('nccloud-router-params', params || {});
        if (onHashChange && typeof onHashChange === "function") {
            onHashChange(getHashValue(params));
        }
    }
    to({ ...othersConfig, page, params, type: 'route', paramInUrl });
}

/**
 * 查找resources加载的文件路径里某一层级的文件名
 * n:Number 在resources的第几层
 */
function _getUrlPathName(n) {
    let hash = "";
    if (CONFIG.isPageModal) {
        let pageStore = getAppUrl().pageurl;
        hash = _decode(pageStore);
    } else {
        hash = _decode(getTopWindow().location.hash);
    }

    let urlPathArr = hash.split("/");
    let name = "";
    name = urlPathArr[n];
    return name;
}

function getUrlPathName() {
    let pathName = getLocation(window).pathname;
    let context = getRunContext();
    if (context?.appInfo) {
        pathName = context.appInfo.ifr;
    }
    return pathName;

}

//获取领域名
function getDomainCode() {
    return _getUrlPathName(1);
}

//获取模块名
function getModuleCode() {
    return _getUrlPathName(2);
}

//返回跳转
function linkBack() {
    history.go(-1);
}

//打开nccloud以外的应用
/**
 * 以新页签的方式打开外部地址
 * @memberof PageTo
 * @param {Url} page 跳转url
 * @param {Params} params 跳转参数
 */
function openOut(page, params) {
    let callback = json => {
        let newPage = page;
        let getHashVals = '';
        if (params) {
            let pageParms = mergeHashVal(page, params);
            getHashVals = pageParms.hash;
            newPage = pageParms.page;
        }
        let url = newPage + (getHashVals ? '?' + getHashVals : '');
        let winObj = window.open(url, "_blank");

        if (!winObj) {
            toast({
                color: 'warning',
                title: json["api-app-pageTo-0001"],
                content: json["api-app-pageTo-0002"],
            });
        }
    };
    getMultiLang({ moduleId: "api_app_pageTo", callback });
}

//将参数拼接到url上
function getHashValue(params, encode, type) {
    let hashVal = '';
    if (params && Object.keys(params).length) {
        let paramsArr = Object.keys(params);
        let len = paramsArr.length;
        for (let i = 0; i < len; i++) {
            let pop = paramsArr[i];
            if (params.hasOwnProperty([pop])) {
                let value = params[pop];
                if (i < len - 1) {
                    if (encode) {
                        value = _toJSON(value, type);
                        hashVal += `${pop}=${_encode(value)}&`;
                    } else {
                        hashVal += `${pop}=${value}&`;
                    }
                } else {
                    if (encode) {
                        value = _toJSON(value, type);
                        hashVal += `${pop}=${_encode(value)}`;
                    } else {
                        hashVal += `${pop}=${value}`;
                    }
                }
            }
        }
    }
    return hashVal;
}

function getPageId(currentPageId, runContext) {
    if (currentPageId) {
        return getAppUrl(undefined, runContext).pageid;
    } else {
        return randomNumber();
    }
}

function randomNumber() {
    const now = new Date();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let hour = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    let insideTabKey = '';
    if (isInsideTab()) { //同时打开很多个页签，这个函数可能会生成相同的值，内部页签下更改一下生成规则
        const crypto = window.crypto || window.msCrypto;
        insideTabKey = crypto.getRandomValues(new Uint16Array(1))[0].toString();
    }
    return now.getFullYear().toString() + month.toString() + day + hour + minutes + seconds + (Math.round(getSafeRandom() * 23 + 100)).toString() + insideTabKey;
}

function getMainUrlKey() {
    let win = getMainWindow(window);
    let origin = getLocation(win).origin;
    let ifr = getLocation(win).href.replace(origin, '');
    let urlKeyMatchs = ifr.match(/urlKey=([^&$]+)/);
    if (urlKeyMatchs && urlKeyMatchs[1]) {
        return urlKeyMatchs[1];
    }
    return 'home';
    
}

function updateHash(history, hash) {
    if (history) {
        history.push(hash);
    } else {
        getLocation(window).hash = hash;
    }
}

function _pushTo({ runContext, paramInUrl, params, page, history, pushToSuccess, urlKey } = {}) {
    let origin = getOrigin();
    let ifr = getMicroHref(runContext).replace(origin, '');
    let hashValue = '';
    if (paramInUrl) {//参数是存 url地址栏 还是存viewModel
        hashValue = getHashValue(params, true, 'route');
        hashValue = ((!page.includes('?')) ? '?' : '&') + hashValue;
    }
    ifr = ifr.includes('#') ? ifr.split('#')[0] : ifr.includes('?') ? ifr.split('?')[0] : ifr;

    if (ifr) {
        if (!ifr.includes("index.html")) {
            ifr = ifr + 'index.html';
        }

        let lastpage = ifr + '#' + page;

        let path = addNCCPrefix(lastpage) + (hashValue || "");
        if (params.appcode || params.billtype) {
            checkNode({
                path,
                params,
                type: 'router',
                callback: () => { // pushTo只改hash
                    if (urlKey) {
                        hashValue = addUrlKey(hashValue, urlKey, true);
                    }
                    updateHash(history, page + (hashValue || ""));

                },
                runContext,
                pushToSuccess,
            });
        } else { //不校验和查询，直接更新hash和sessionStorag
            let param = (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) ?
                getAppUrl(undefined, runContext).pageurl :
                getLocation(getParentWindow(window)).hash.split('?')[1];

            let Arr = param && param.split('&');
            if (Arr && Arr instanceof Array && Arr.length > 0) {
                let newArr = Arr.map(item => {
                    if (item.indexOf('=') != -1 && item.split('=') && item.split('=') instanceof Array) {
                        if (item.split('=')[0] === 'ifr' && path) {
                            item = `ifr=${_encode(path)}`;
                        }
                        if (item.split('=')[0] === 'p' && params.pagecode) {
                            item = `p=${_encode(params.pagecode)}`;
                        }
                        return item;
                    }
                });

                //内部页签下，还需要同步ifr和pagecode到runContext
                // let newUrlParam = { ifr: path };
                // if(params.pagecode){
                //     newUrlParam.p = params.pagecode;
                // }
                // if(typeof pushToSuccess == "function"){
                //     pushToSuccess(newUrlParam);
                // }else{
                //     syncRunContext(newUrlParam);
                // } 
                //syncUrlKeyStorage(newUrlParam)

                let newParams = newArr.join('&');

                if (CONFIG.isRemoveWorkbench) {//去掉workbench打开       
                    if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) { //放session
                        let windowTabId = randomNumber();
                        getParentWindow(window).location.hash = page + `?page=${windowTabId}`;
                        let resPage = path + (hashValue ? (hashValue + newParams) : '?' + newParams);
                        setAppUrl(windowTabId, resPage);
                    } else {//不放session
                        let resHash = page + (hashValue ? (hashValue + newParams) : '?' + newParams);
                        getLocation(window).hash = resHash;
                    }
                } else { //带着workbench打开
                    if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) {
                        // let windowTabId = getPageId(true, runContext);
                        // urlKey才是自身的，windowTabId是当前激活页签的
                        let windowTabId = urlKey; // YBP-CCF-BUG-2900
                        //getParentWindow(window).location.hash = `#/ifr?page=${windowTabId}`;
                        setAppUrl(windowTabId, newParams);
                    }
                    else {
                        getParentWindow(window).location.hash = `#/ifr?${newParams}`;
                    }
                    let newHistory = page + (hashValue ? (((hashValue.startsWith('?') || page.includes('?')) ? '' : '?') + hashValue) : "");
                    if (urlKey) {
                        newHistory = addUrlKey(newHistory, urlKey, true);
                    }
                    updateHash(history, newHistory);
                }
            }
        }
    }
}

//跳转
function to(configParams) {
    let {
        page, //跳转节点路径
        params = {}, //跳转参数
        type, //类型 open-新页签，link-当前页签-非单页应用 router当前页签-单页应用
        onHashChange, //hash参数改变的回调函数--共享服务用
        special = false, //是否占用license 默认是false
        getWinObj, //openTo时获取打开页签的window对象
        parentParam, //打开节点传递的参数,作为上下文参数，传给ajax系统参数使用，如 共享的 custom
        paramInUrl,
        uniqueTab, // openTo情况下，是否页签去重
        isAddNCCPrefixPath = true, // openTo情况下，是否添加 nccloud/resources 前缀
        crossTabData, //跨页签通信参数
        runContext,
        pushToSuccess,
        openCheck = true,
        isSkipPower = false,
        is_cloud_app = false, //是否是云应用
    } = configParams;

    if (!runContext) {
        runContext = getRunContext();
    }

    let history = getMicroHistory(runContext);
    if (history) {
        paramInUrl = true;
    }

    let urlKey = getUrlKey();

    if (page) {
        //pushTo或者linkTo是同步urlKey

        // if(type == 'route' || type == 'link'){
        //     let urlKey = syncUrlKeyStorage(params);
        //     if(urlKey){
        //         params.urlKey = urlKey;
        //     }
        // }
        //
        if (type == 'route') {
            _pushTo({ runContext, paramInUrl, params, page, history, pushToSuccess, urlKey });
            return;
        }

        for (let pop in params) {
            if (typeof params[pop] === "string") {
                if (params[pop].includes('#') || params[pop].includes('?')) {
                    params[pop] = _encode(params[pop]);
                }
            }
        }
        let newPageParams = mergeHashVal(page, params);
        let hashVal = newPageParams.hash;
        page = newPageParams.page;

        //判断有无 index.html
        let nextPage = page;
        if (page.includes("#")) {
            if (!(page.split("#")[0].includes("index.html"))) {
                nextPage = page.split("#")[0] + 'index.html' + '#' + (page.split("#")[1] ? page.split("#")[1] : '');
            } else {
                nextPage = page;
            }
        } else {
            if (!page.includes("index.html")) {
                nextPage = page + 'index.html';
            }
        }
        let currentHref = getUrlPathName();
        if (type === 'link' && currentHref.includes(nextPage) && hashVal) {
            if (params.appcode) { // 传了appcode需要校验查询后台参数
                let path = '';
                if (nextPage.includes("#")) {
                    path = addNCCPrefix(nextPage) + '?' + hashVal;
                } else {
                    path = addNCCPrefix(nextPage) + '#/?' + hashVal;
                }
                checkNode({
                    path,
                    params,
                    type,
                    special,
                    getWinObj,
                    parentParam,
                    callback: (newParam, newKey) => {
                        updateLinkHref({ type, newParam, urlKey: newKey || urlKey });
                    },
                    runContext,
                    isSkipPower,
                    is_cloud_app,
                });
            } else {// 没有appcode直接更新sessionStorage
                //地址相同，只改hash
                let locationHash = hashVal;
                if (urlKey) {
                    locationHash = addUrlKey(hashVal, urlKey, true);
                }
                updateHash(history, locationHash);
                setParentIfr(nextPage, hashVal, runContext);
            }
        } else {
            let path = '';
            if (nextPage.includes("#")) {
                path = (isAddNCCPrefixPath ? addNCCPrefix(nextPage) : nextPage) + '?' + hashVal;
            } else {
                path = (isAddNCCPrefixPath ? addNCCPrefix(nextPage) : nextPage) + '#/?' + hashVal;
            }

            if (type == 'open' && !openCheck) {
                let breadCrumbParam = getBreadCrumb(parentParam, '', params);
                let newParams = {
                    ifr: path,
                    c: parentParam?.appcode,
                    ar: parentParam?.appid,
                    p: parentParam?.pagecode,
                    //lang: getLangCode(),
                    //n: params.nccloud_menu_name_self || resParam.fifthmenu || resParam.getHashValuemenu,
                };
                let newParam = getHashValue(newParams, true) + breadCrumbParam;
                let windowTabId = randomNumber();
                let newPage = `#/ifr?page=${windowTabId}`;
                setAppUrl(windowTabId, newParam);
                let commontOpenNewWindow = getParentWindow(window).commontOpenNewWindow;
                if (typeof commontOpenNewWindow === 'function') {
                    commontOpenNewWindow(window, newPage, windowTabId, '', crossTabData);
                }
                return;
            }
            checkNode({
                path,
                params,
                type,
                special,
                getWinObj,
                parentParam,
                callback: (newParam, newKey) => {
                    updateLinkHref({ type, newParam, urlKey: newKey || urlKey });
                },
                uniqueTab,
                crossTabData,
                runContext,
                isSkipPower,
                is_cloud_app,
            });
        }
        //共享hashChange回调
        if (onHashChange && typeof onHashChange == "function") {
            onHashChange(hashVal);
        }
    } else {
        checkNode({
            params,
            type,
            special,
            getWinObj,
            parentParam,
            uniqueTab,
            callback: (newParam, newKey) => {
                updateLinkHref({ type, newParam, urlKey: newKey || urlKey });
            },
            crossTabData,
            runContext,
            isSkipPower,
            is_cloud_app,
        });
    }
}

function updateLinkHref({ type, newParam, urlKey } = {}) {
    if (type == 'link') {
        // 解决linkTo的内存泄漏问题：document.querySelector('#app') && ReactDOM.unmountComponentAtNode(document.querySelector('#app'))
        let href = newParam.ifr;
        document.querySelector('#app') && ReactDOM.unmountComponentAtNode(document.querySelector('#app'));
        getLocation(window).href = addUrlKey(href, urlKey);

    }
}

function addUrlKey(href, urlKey, isHash) {
    if (!href.includes('#') && !isHash) {
        return href + '#/?' + '&urlKey=' + urlKey;
    } else if (!href.includes('?')) {
        return href + '?' + '&urlKey=' + urlKey;
    } else {
        return href + '&urlKey=' + urlKey;
    }
}

//获取父window参数
function getSearchParam(pop, otherConfig = {}) {
    let { runContext } = otherConfig;
    if (!pop) { return; }

    //先判断若是乾坤模式，则从当前的history中取应用编码 页面编码
    let param = getMicroContext(runContext);
    if (param) {
        return param[pop];
    }

    //否则不是乾坤模式，从父window.location中取

    let path = getParentWindow(window).location.hash || getParentWindow(window).location.search;

    //--------------- 此处为改url参数代码---------------------//
    if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) {
        path = '?' + getAppUrl(undefined, runContext).pageurl;
    }
    //否则：按照原来方式走
    let result = getParamInPath(pop, path);
    return result;
}

function getParamInPath(pop, path) {
    let result = '';
    //否则：按照原来方式走
    let appSearch = path.includes('?') ? path.split('?')[1] : path.substring(1);
    if (appSearch) {
        let appPrams = appSearch.split('&');
        if (appPrams && appPrams instanceof Array) {
            if (pop === 'allPageContext') {
                result = {};
                const resultKeyMap = {
                    c: 'appcode',
                    p: 'pagecode',
                    n: 'appname',
                    ar: 'appid',
                    b1: 'field',
                    b2: 'module',
                    b3: 'menuclass',
                    b4: 'menu',
                    //b5: 'fifthmenu',
                };
                appPrams.forEach(item => {
                    if (item.indexOf('=') != -1 && item.split('=') && item.split('=') instanceof Array) {
                        result[resultKeyMap[item.split('=')[0]]] = _decode(item.split('=')[1]);
                    }
                });
            } else {
                let resItem = appPrams.find(item => item.indexOf('=') != -1 && Array.isArray(item.split('=')) && item.split('=')[0] === pop);
                if (resItem && resItem.split('=')[1]) {
                    result = _decode(resItem.split('=')[1]);
                }
            }
        }
    }
    return result;
}

//获取顶层window参数
function getTopParam(pop) {
    if (!pop) { return; }
    let path = getTopWindow(window).location.hash || getTopWindow(window).location.search;

    //--------------- 此处为改url参数代码---------------------//
    if (CONFIG.isPageModal) {
        path = '?' + getAppUrl().pageurl;
    }
    //--------------- 此处为改url参数代码---------------------//
    let result = getParamInPath(pop, path);
    return result;

}

/**
 * 获取工作台参数，如appcode应用编码,  pagecode页面编码，appname应用名称，appid应用id, field领域名, module模块名, menuclass菜单分类， menu菜单名称
 * @memberof PageTo
 * @param {string} str 参数名: appcode应用编码,  pagecode页面编码，appname应用名称，appid应用id, field领域名, module模块名, menuclass菜单分类， menu菜单名称
 * @returns {string} 
 */
function getPageContext(pop) {
    if (typeof pop === "string" && contextKeyMap[pop]) {
        return getSearchParam(contextKeyMap[pop]);
    } else {
        return getSearchParam('allPageContext');
    }
}

/**
 * 设置工作台参数，如应用编码、页面编码、菜单
 * @memberof PageTo
 * @param {ContextData} popObj 参数: {appcode:'应用编码',pagecode: '页面编码"，appname:'应用名称",appid:'应用id', field:'领域名', module:'模块名', menuclass:'菜单分类',menu:'菜单名称'}
 */
function setPageContext(popObj) {
    if (Object.prototype.toString.call(popObj) != '[object Object]') { return; }

    let path = getParentWindow(window).location.hash;
    let pageid = '';
    if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) {
        path = getAppUrl().pageurl;
        pageid = getAppUrl().pageid;
    }
    let paramArr = path.split("&");

    let newParam = paramArr.map(e => {
        if (e.includes("=") && popObj[contextKeyMap[e.split("=")[0]]]) {
            return `${e.split("=")[0]}=${popObj[contextKeyMap[e.split("=")[0]]]}`;
        }
        return e;
    });
    let newPath = newParam.join("&");

    if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) {
        setAppUrl(pageid, newPath);
    } else {
        getParentWindow(window).location.hash = newPath;
    }
}

function setPageCode(pagecode) {
    if (!pagecode) { return; }
    let popObj = { c: pagecode };
    setPageContext(popObj);
}

function getAppCode(otherConfig) {
    return getSearchParam("c", otherConfig);
}

function getPageCode(otherConfig) {
    return getSearchParam("p", otherConfig);
}

//校验节点权限并修改父窗口url参数
function checkNode(configParams) {
    let {
        path,
        params = {},
        type,
        callback,
        special,
        getWinObj,
        parentParam,
        uniqueTab = false, //是否页签去重
        crossTabData,
        runContext,
        pushToSuccess,
        isSkipPower,
        is_cloud_app,
    } = configParams;
    let tab = '';
    if (uniqueTab && type === 'open') {
        tab = 'switch'; //去重 若已经有页签打开过了 则直接定位到已有页签，否则打开新页签
    } else if (type === 'open') {
        tab = 'tab';
    }
    if (isInsideTab() && type == "router") {
        tab = "router";
    }
    let appcode = params && params.appcode;
    let urlAppcode = getSearchParam('c', { runContext: runContext });
    let pagecode = (params && params.pagecode) || '';
    //去掉 workbench 时使用 topOpenCheck,  否则带着workbench模式使用getTopWindow().openCheck
    //若getTopWindow().openCheck不存在，为了不报错 使用topOpenCheck
    let openCheck = CONFIG.isRemoveWorkbench ? topOpenCheck : getTopWindow().openCheck || topOpenCheck;
    if (special) {
        openCheck = CONFIG.isRemoveWorkbench ? topSpecialOpenCheck : getTopWindow().specialOpenCheck || topSpecialOpenCheck;
    }

    let oldWinHash = '';
    if ((type === 'open' || getParentWindow(window) === getTopWindow()) && CONFIG.isPageModal) {
        let oldUrl = getAppUrl(undefined, runContext).pageurl;
        oldWinHash = CONFIG.isRemoveWorkbench ? oldUrl : (oldUrl.includes('?') ? oldUrl : ('?' + oldUrl));
    } else {
        oldWinHash = getLocation(getParentWindow(window)).hash;
    }

    if (appcode) {
        openCheck(
            appcode,
            pagecode,
            (win, res, openWinCallBack) => {
                checkCallBack({
                    win, //打开页签window
                    res, //后台返回应用信息
                    path, // 业务传递url
                    appcode,
                    pagecode,
                    type, //打开方式 'open' 'link' 'router'
                    oldWinHash, //原来的参数
                    params, //业务传新参数
                    onChangeRouter: callback, //打开页面后的回调
                    parentParam, //业务传给父window参数  作为上下文参数，传给ajax系统参数使用，如 共享的 custom
                    openWinCallBack,
                    uniqueTab, // 页签去重
                    runContext,
                    pushToSuccess,
                });
                //业务监听新页签window
                if (typeof getWinObj === 'function') {
                    getWinObj(win);
                }
            },
            tab,
            { crossTabData, menucode: params.menucode, toastContainer: document.body, isSkipPower, is_cloud_app },
        );
    } else if (params && params.billtype) {
        //通过billtype查appcode
        let sencetype = '1';
        window.actionName = '请求url参数';
        ajax({
            url: '/nccloud/platform/pub/getappurl.do',
            method: 'post',
            data: {
                billpk: params.billpk || params.id,
                billtypecode: params.billtype,
                pagecode: pagecode || null,
                sence: params.sence || sencetype,
            },
            success: result => {
                //查到以后校验
                if (result.success && result.data && result.data.appPageVO) {
                    let resurl = result.data.appPageVO.pageurl.replace("nccloud/resources/", "");
                    let resPageUrl = getResPageUrl(resurl, params);
                    openCheck(
                        result.data.appcode,
                        pagecode || result.data.appPageVO.pagecode,
                        (win, res, openWinCallBack) => {
                            checkCallBack({
                                win, //打开页签window
                                res, //后台返回应用信息
                                path: resPageUrl, // 业务传递url
                                appcode: result.data.appcode,
                                pagecode: pagecode || result.data.appPageVO.pagecode,
                                type, //打开方式 'open' 'link' 'router'
                                oldWinHash, //原来的参数
                                params, //业务传新参数
                                onChangeRouter: callback, //打开页面后的回调
                                parentParam, //业务传给父window参数  作为上下文参数，传给ajax系统参数使用，如 共享的 custom
                                openWinCallBack,
                                uniqueTab, //页签去重
                                runContext,
                                pushToSuccess,
                            });
                            //业务监听新页签window
                            if (typeof getWinObj === 'function') {
                                getWinObj(win);
                            }
                        },
                        tab,
                        { crossTabData, menucode: params.menucode, toastContainer: document.body, isSkipPower, is_cloud_app },
                    );
                } else {
                    console.log('appcode请求失败');
                }
            },
        });
    } else if (urlAppcode) {
        openCheck(
            urlAppcode,
            pagecode,
            (win, res, openWinCallBack) => {
                checkCallBack({
                    win, //打开页签window
                    res, //后台返回应用信息
                    path, // 业务传递url
                    appcode: urlAppcode,
                    pagecode: pagecode,
                    type, //打开方式 'open' 'link' 'router'
                    oldWinHash, //原来的参数
                    params, //业务传新参数
                    onChangeRouter: callback, //打开页面后的回调
                    parentParam, //业务传给父window参数  作为上下文参数，传给ajax系统参数使用，如 共享的 custom
                    openWinCallBack,
                    uniqueTab, //页签去重
                    runContext,
                    pushToSuccess,
                });
                //业务监听新页签window
                if (typeof getWinObj === 'function') {
                    getWinObj(win);
                }
            },
            tab,
            { crossTabData, menucode: params.menucode, toastContainer: document.body, isSkipPower, is_cloud_app },
        );
    } else {
        // 无appcode
        console.log('请传入appcode或billtype');
    }
}

//新参数 覆盖旧参数
function mergeHashVal(pageurl, params = {}, encode = false) {
    let getHashVals = '';
    let hashArr = [];
    let urlParm = '';
    let newPage = pageurl;
    if (pageurl.includes('?')) {
        urlParm = pageurl.split('?')[1];
        newPage = pageurl.split('?')[0];
    }
    let hasItemFlag = {};
    if (urlParm) {
        let paramsVal = urlParm.split('&');
        if (paramsVal && paramsVal instanceof Array && paramsVal.length > 0) {
            hashArr = paramsVal.map(elem => {
                if (elem.indexOf('=') != -1 && elem.split('=') && elem.split('=') instanceof Array) {
                    if (params && params[elem.split('=')[0]]) {
                        hasItemFlag[`${elem.split('=')[0]}`] = true;
                        elem = `${elem.split('=')[0]}=${encode ? _encode(params[elem.split('=')[0]]) : params[elem.split('=')[0]]}`;
                    }
                }
                return elem;
            });
            for (let pop in params) {
                if (!hasItemFlag[pop]) {
                    hashArr.push(`${pop}=${encode ? _encode(params[pop]) : params[pop]}`);
                }

            }
            getHashVals = hashArr.join('&');
        }
    } else {
        getHashVals = getHashValue(params, encode);
    }
    return {
        hash: getHashVals,
        page: newPage,
    };
}

//分离出url
function getResPageUrl(pageurl, params = {}) {
    let newPath = '';
    if (pageurl) {
        let pageParms = mergeHashVal(pageurl, params);
        let getHashVals = pageParms.hash;
        let newPage = pageParms.page;
        if (newPage.includes("#")) {
            newPath = addNCCPrefix(newPage) + (getHashVals ? '?' + getHashVals : '');
        } else {
            newPath = addNCCPrefix(newPage) + (getHashVals ? '#/?' + getHashVals : '');
        }

    }
    return newPath;
}

function addNCCPrefix(url) {
    // if(url.startsWith('../')){
    //     return url;
    // }
    // let hasNCCPrefix = /^(\/nccloud|nccloud)\/resources*/.test(url);
    // if (hasNCCPrefix) {
    //     url = url.replace(/^(\/nccloud|nccloud)\/resources*/, '../../../..');
    // } else {
    //     url = url[0] === '/' ? '../../../..' + url : '../../../../' + url; 
    // }
    let env = 'production';
    if (getTopWindow() && getTopWindow().environmentmodel) {
        env = getTopWindow().environmentmodel;
    }

    if (url && (url.substring(0, 7) === '/ncchr/' || url.substring(0, 6) === 'ncchr/')) {
        return url;
    }

    if (url.startsWith('../')) {
        return url;
    }
    let hasNCCPrefix = /^(\/yonbip|yonbip|\/nccloud|nccloud)\/resources*/.test(url);
    // if (env === 'development') {
    //     url = url.replace(/^(\/yonbip|yonbip|\/nccloud|nccloud)\/resources*/, '');
    //     return url;
    // }
    if (hasNCCPrefix) {
        url = url.replace(/^(\/yonbip|yonbip|\/nccloud|nccloud)\/resources*/, '../../../..');
    } else {
        url = url[0] === '/' ? '../../../..' + url : '../../../../' + url;
    }

    return url;
    // let env = 'production';
    // if (getTopWindow() && getTopWindow().environmentmodel) {
    //     env = getTopWindow().environmentmodel;
    // }
    // let hasSep = url[0] === '/';
    // //let hasNCCPrefix = /^(\/nccloud|nccloud)\/resources*/.test(url);
    // let hasNCCPrefix = url.includes('/resources/');
    // let isRelative = url.startsWith('../');
    // if (env === 'development' || hasNCCPrefix || isRelative) {
    //     //开发环境 不加NCC前缀不加NCC前缀
    //     return url;
    // } else if (hasSep) {
    //     return '/nccloud/resources' + url;
    // } else {
    //     return '/nccloud/resources/' + url;
    // }
}

/**
 * 以新页签方式打开节点，不占用license
 * @memberof PageTo
 * @param {Url} page 跳转url
 * @param {Params} params 跳转参数, 参数格式为：{ key1: value1, key2: value2 }
 * @param {function} getWinObj 获取打开后的window对象回调(win)=>{}
 * @param {ParentParams} parentParam 跳转往window上加参数 ,作为上下文参数，传给ajax系统参数使用，如 共享的 custom
 * @param {OtherConfig} otherConfig 其他参数, uniqueTab:是否页签去重, 默认是false; <br/> isAddNCCPrefixPath:生产环境page是否自动加前缀'nccloud/resources/', 默认是true;<br/>
 */
function specialOpenTo(page, params, getWinObj, parentParam, option = {}) {
    let { uniqueTab = false, isAddNCCPrefixPath = true } = option;
    //special 为不占用license}
    to({
        ...option,
        page,
        params,
        type: 'open',
        special: true,
        getWinObj,
        parentParam,
        uniqueTab,
        isAddNCCPrefixPath,
    });
}

/**
 * 在当前页打开节点，不占用license
 * @memberof PageTo
 * @param {Url} page 跳转url
 * @param {Params} params 跳转参数, 参数格式为：{ key1: value1, key2: value2 }
 * @param {function} getWinObj 获取打开后的window对象回调(win)=>{}
 * @param {ParentParams} parentParam 跳转往window上加参数,作为上下文参数，传给ajax系统参数使用，如 共享的 custom
 */
function specialLinkTo(page, params, getWinObj, parentParam, othersConfig = {}) {
    //special 为不占用license
    to({ ...othersConfig, page, params, type: 'link', special: true, getWinObj, parentParam });
}

function specialOpenToOut(page, params, getWinObj, parentParam) {
    let hashVal = '';
    if (params) {
        let pageParms = mergeHashVal(page, params);
        hashVal = pageParms.hash;
        page = pageParms.page;
    }
    let path = page + (hashVal ? '?' + hashVal : '');
    checkNode({
        path,
        params,
        type: 'open',
        special: true,
        getWinObj,
        parentParam,
    });
}

/**
 * 获取页面url参数
 * @memberof PageTo
 * @param {string} str 参数名
 * @param {OtherConfig} othersConfig 其他参数,paramInUrl：跳转参数是否放地址栏(刷新不丢失)，默认是false,刷新丢失
 * @returns {string} 
 */
function getUrlParam(pop, othersConfig = {}) {
    if (Array.isArray(pop)) {
        pop = pop[0];
    }
    let { paramInUrl = false, hashFirst = true, runContext } = othersConfig;
    let resultMap = new Map();

    let history = getMicroHistory(runContext);
    if (history) {
        paramInUrl = true;
    }
    if (!paramInUrl) {
        let routerParam = ViewModel.getData('nccloud-router-params');
        //若为 pushTo 单页应用，把url存到ViewModal中--------------------新修改
        if (routerParam) {
            if (typeof pop === "string") {
                return routerParam?.[pop];          
            } else {
                return routerParam;
            }

        }
    }

    let queryString = getMicroLocation(runContext).hash || getMicroLocation(runContext).search;
    if (!hashFirst) {
        queryString = getMicroLocation(runContext).search;
    }
    queryString = queryString.includes('?') ? queryString.split('?')[1] : queryString.substring(1);
    if (queryString) {
        let paramsArr = queryString.split('&');
        if (paramsArr && paramsArr instanceof Array) {
            paramsArr.forEach(item => {
                if (item.indexOf('=') != -1 && item.split('=') && item.split('=') instanceof Array) {
                    resultMap.set(item.split('=')[0], _parseJSON(_decode(_decode(item.split('=')[1]))));
                }
            });
        }
    }
    if (typeof pop === "string") {
        return resultMap.get(pop);
    } else {
        return Object.fromEntries(resultMap);
    }
}

/**
 * 修改页面url参数
 * @memberof PageTo
 * @param {Params} params 修改的参数对象：{ key1: value1, key2:value2 }
 * @param {function} onHashChange hash 改变的回调
 * @param {OtherConfig} othersConfig 其他参数,paramInUrl：跳转参数是否放地址栏(刷新不丢失)，默认是false,刷新丢失
 */
function setUrlParam(params, onHashChange, othersConfig = {}) {
    let { paramInUrl = false, runContext } = othersConfig;
    runContext = getRunContext(runContext);
    // pop是字符串时，设置id属性
    // pop是对象时，设置其他属性
    if (!params) { return; }

    let history = getMicroHistory(runContext);

    let origin = getOrigin();
    let path = getMicroHref(runContext).replace(origin, "");

    //参数放viewModal
    if (!history && !paramInUrl) {
        let routerParam = ViewModel.getData('nccloud-router-params');
        //若为 pushTo 单页应用，把url存到ViewModal中--------------------新修改
        if (!routerParam && !path.includes('?')) { //刷新后 新增设置
            routerParam = {};
        }
        if (routerParam) {
            if (typeof params === 'string') {
                routerParam['id'] = params;
            }
            if (typeof params === 'object') {
                for (let pop in params) {
                    routerParam[pop] = params[pop];
                }
            }
            ViewModel.setData('nccloud-router-params', routerParam);
            if (onHashChange && typeof onHashChange === "function") {
                onHashChange(getHashValue(routerParam));
            }
            return;
        }
    }

    //否则为linkTo或openTo打开得节点
    //原来有参数才有？若原来没有参数，直接增加参数
    let hashObj = new Map();
    let page = path;
    //获取旧参数
    if (path.includes('#')) {//参数只放在#的？号后面 
        // "/nccloud/resources/arap/retention/reduce/list/index.html?t=1713514456617#/Card?status=add&type=transfer
        let queryString = '';
        let [hashF, hashB] = path.split("#");
        if (hashB.includes('?')) {
            queryString = hashB.split('?')[1];
            page = hashF + '#' + hashB.split('?')[0];
        }
        if (queryString) {
            let paramsVal = queryString.split('&');
            if (paramsVal && paramsVal instanceof Array && paramsVal.length > 0) {
                paramsVal.forEach(elem => {
                    if (elem.indexOf('=') != -1 && elem.split('=') && elem.split('=') instanceof Array) {
                        hashObj.set(elem.split('=')[0], elem.split('=')[1]);
                    }
                });
            }
        }
    }
    //添加新参数
    if (typeof params === 'string') {
        hashObj.set('id', encodeURIComponent(_toJSON(params)));
    }
    if (typeof params === 'object') {
        for (let pop in params) {
            hashObj.set(pop, encodeURIComponent(_toJSON(params[pop])));
        }
    }
    let hashArr = [];
    //整理参数格式
    for (let [key, value] of hashObj) {
        hashArr.push(`${key}=${value}`);
    }
    let search = hashArr.join('&');

    //设置hash
    let hash = '';
    if (path.includes('#')) {
        let oldHash = path.split('#')[1];
        let oldRouter = oldHash;
        if (oldHash.includes('?')) {
            oldRouter = oldHash.split('?')[0];
        }
        hash = oldRouter + '?' + search;
    } else {
        hash = "/?" + search;
    }
    updateHash(history, hash);
    setParentIfr(page, search, runContext);
}

/**
 * 新增页面url参数
 * @memberof PageTo
 * @param {Params} params 新增的参数对象：{ key1: value1, key2:value2 }
 * @param {function} onHashChange hash 改变的回调
 * @param {OtherConfig} othersConfig 其他参数,paramInUrl：跳转参数是否放地址栏(刷新不丢失)，默认是false,刷新丢失
 */
function addUrlParam(popObj, onHashChange, othersConfig = {}) {
    setUrlParam(popObj, onHashChange, othersConfig);
}

//处理复杂类型url参数
function _toJSON(param, type) {
    //return JSON.stringify(param);
    //只有对象或者数组转json,其他类型不转json
    let _type = typeof param;
    if (param === null) { //null参数不能压缩否则解压完会变成''
        _type = 'null'; //业务传了null 获取到的参数也需要是null
    }
    if ((typeof param === 'object') || typeof param === 'boolean' || typeof param === 'undefined' || (type == 'route' && typeof param === 'number')) {
        var JSONObj = {
            __isTransferJson: true,
            __type: _type,
            value: _type === 'object' ? gziptools.zip(JSON.stringify(param)) : param,
        };
        return JSON.stringify(JSONObj);
    } else {
        return param;
    }
}
//解析复杂类型url
function _parseJSON(param) {
    try {
        let parseParam = JSON.parse(param);
        let __type = parseParam.__type;
        //全部parse后，只有数组或者对象返回parse后，其他类型不返回parse后的
        //此处有bug,: 业务传的参数是一个JSON，但获取后变成了对象，因为此处转出了问题
        if ((__type === 'object' || __type === 'null' || __type === "boolean" || __type === 'undefined' || __type === 'number') && parseParam.__isTransferJson) { //只有_toJSON处理过的属性才parse
            let originParam = parseParam.value;
            if (__type === 'object') {
                originParam = gziptools.unzip(originParam);
            }
            console.log(originParam);
            return originParam;
        }
        // else if(typeof parseParam === "boolean"){
        //     //布尔类型encode后都变成了字符串
        //     //所以布尔类型需要输出给业务parse后的
        //     return parseParam;
        // }
        else {
            return param;
        }
    } catch (e) {
        return param;
    }
}

/**
 * 删除页面url参数
 * @memberof PageTo
 * @param {string | Array} str 删除url参数
 * @param {function} onHashChange hash 改变的回调
 * @param {OtherConfig} othersConfig 其他参数,paramInUrl：跳转参数是否放地址栏(刷新不丢失)，默认是false,刷新丢失
 */
function delUrlParam(str, onHashChange, othersConfig = {}) {
    let { paramInUrl = false, runContext } = othersConfig;
    if (!str) { return; }
    runContext = getRunContext(runContext);
    let history = getMicroHistory(runContext);

    if (!history && !paramInUrl) {
        let routerParam = ViewModel.getData('nccloud-router-params');
        //若为 pushTo 单页应用，把url存到ViewModal中--------------------新修改
        if (routerParam) {
            if (typeof str === "string") {
                if (routerParam[str]) {
                    delete routerParam[str];
                }
            }
            if (Array.isArray(str) && str.length) {
                str.forEach(item => {
                    if (routerParam[item]) {
                        delete routerParam[item];
                    }
                });
            }
            ViewModel.setData('nccloud-router-params', routerParam);
            if (onHashChange && typeof onHashChange === "function") {
                onHashChange(getHashValue(routerParam));
            }
            return;
        }
    }

    let origin = getOrigin();
    let page = getMicroHref(runContext).replace(origin, "");
    if (page.includes("#")) {
        let paramStr = '';
        let [newPage, hash] = page.split("#");
        if (hash.includes('?')) {
            paramStr = hash.split('?')[1];
            newPage = newPage + '#' + hash.split('?')[0];
        }
        if (paramStr) {
            let paramArr = paramStr.split("&");
            if (Array.isArray(paramArr) && paramArr.length) {
                //改为map,checkmarx推荐修改
                let paramObj = new Map();
                let newParamArr = [];
                paramArr.forEach((item => {
                    if (item.includes("=") && item.split("=")[1]) {
                        paramObj.set(item.split("=")[0], item.split("=")[1]);
                    }
                }));
                if (typeof str === "string") {
                    if (paramObj.has(str)) {
                        paramObj.delete(str);
                    }
                }
                if (Array.isArray(str) && str.length) {
                    str.forEach(item => {
                        if (paramObj.has(item)) {
                            paramObj.delete(item);
                        }
                    });
                }
                for (let [key, value] of paramObj) {
                    newParamArr.push(`${key}=${value}`);
                }
                let hashVal = '';
                if (newParamArr.length) {
                    hashVal = newParamArr.join("&");
                }
                let history = getMicroHistory(runContext);
                if (newPage.includes('#')) {
                    let hash = newPage.split("#")[1] + "?" + hashVal;
                    updateHash(history, hash);
                } else {
                    updateHash(history, "/?" + hashVal);
                }
                setParentIfr(newPage, hashVal, runContext);
            }
        }
    }
}

//设置父window的url
function setParentIfr(page, hashVal, runContext) {
    let path = addNCCPrefix(page) + (page.includes("#") ? '?' : '#/?') + hashVal;

    let storageKey = _getStorageKey(runContext);

    let params = getParentWindow(window).location.hash.split('?')[1];
    let pageVal = '';
    if (storageKey && CONFIG.isPageModal) {
        let pageStore = getAppUrl(storageKey);
        params = pageStore.pageurl;
        pageVal = pageStore.pageid;
    }
    console.log("页签编码=======", pageVal, storageKey, runContext);
    let Arr = params && params.split('&');
    if (Arr && Arr instanceof Array && Arr.length > 0) {
        let newArr = Arr.map(item => {
            if (item.indexOf('=') != -1 && item.split('=') && item.split('=') instanceof Array) {
                if (item.split('=')[0] === 'ifr' && path) {
                    item = `ifr=${_encode(path)}`;
                }
                return item;
            }
        });

        let newParams = newArr.join('&');
        //修改工作台路径
        if (storageKey && CONFIG.isPageModal) {
            console.log("页签编码=======", pageVal, newParams);
            setAppUrl(pageVal, newParams);
        }
        else {
            getParentWindow(window).location.hash = `#/ifr?${newParams}`;
        }

    }
}

//判断是修改顶层 sessionStorage 的参数 还是本层 location 参数
//场景1:  代码位置乾坤内单据,    parent==top, window有runcontext, 无urlkey    需要根据runContext的appkey同步修改sesionStorage
//场景2： 代码位置第一层iframe内单据(浏览器页签)   parent===top  window无runcontext，有urlkey   需要根据urlKey同步修改sesionStorage

//场景3： 代码位置乾坤内的第一层iframe,  parent===top  window无runContext, 有urlkey, 修改location   需要根据urlKey同步修改sesionStorage

//场景4： 代码位于乾坤内的第二层iframe parent!=top  不需要同步parent  window无runContext, 无urlkey
//场景5:  代码位置iframe内的iframe  修改location  parent!=top 不需要同步parent   window无runContext, 无urlkey

function _getStorageKey(runContext) {
    if (getParentWindow(window) === getTopWindow()) {
        if (runContext) { //乾坤模式加载的单据
            //同步sessionStorage到 runContext的appkey中
            return runContext.appKey;
        } else {
            let urlKey = '';
            let urlKeyMatchs = getLocation(window).href.match(/urlKey=([^&$]+)/);
            if (urlKeyMatchs && urlKeyMatchs[1]) {
                urlKey = urlKeyMatchs[1];
            }
            if (urlKey) {
                return urlKey;
            }
        }
    }
}

/**
 * 给父window窗口设置参数, 作为业务扩展系统参数custom; ajax请求时传给后台，openTo打开页签时，会携着该参数跳转，共享的集团信息需求
 * @memberof PageTo
 * @param {ParentParams} str JSON对象
 */
function addParentUrlParam(params) {
    if (params && typeof params === "string") {
        let runContext = getRunContext();
        let hash = '', pageVal = '', newHash = "";
        if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) { //修改顶层参数
            let pageStore = getAppUrl(undefined, runContext);
            pageVal = pageStore.pageid;
            hash = pageStore.pageurl;
            newHash = hash + `&custom=${_encode(params)}`;
            setAppUrl(pageVal, newHash);
        } else { // 修改其它层参数
            hash = getParentWindow(window).location.hash;
            if (hash.includes("?")) {//有？,向后面加参数
                newHash = hash + `&custom=${_encode(params)}`;
            } else if (hash.includes("#")) { // 有#,无？
                newHash = hash + `?custom=${_encode(params)}`;
            } else {//无？也无#
                newHash = hash + `#/?custom=${_encode(params)}`;
            }
            getParentWindow(window).location.hash = newHash;
        }
    }
}

/**
 * 删除父window窗口的系统参数 custom 业务自定义扩展参数 共享的集团信息,ajax请求时传给后台，
 * @memberof PageTo
 */
function deleteParentUrlParam() {
    let hash = '', pageVal = '';
    if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) { //修改顶层参数
        let runContext = getRunContext();
        let pageStore = getAppUrl(undefined, runContext);
        pageVal = pageStore.pageid;
        hash = pageStore.pageurl;
        //若存在custom属性，则将改属性删除
        hash = deleteHashParam(hash);
        setAppUrl(pageVal, hash);
    } else { // 修改其它层参数
        hash = getParentWindow(window).location.hash;
        hash = deleteHashParam(hash);
        getParentWindow(window).location.hash = hash;
    }
}

function deleteHashParam(hash) {
    let params = hash.split('&');
    let index = params.findIndex(item => {
        return item.includes('custom=');
    });
    if (index !== -1) {
        params.splice(index, 1);
        hash = params.join("&");
    }
    return hash;
}

/**
 * 根据单据类型打开节点
 * @memberof PageTo
 * @param {BillInfo} option { billpk:'联查页面的单据pk', billtype:'联查页面的单据类型', type:'前页签打开link'/'新页签打开open' }
 */
function openAppByBilltype(option) {
    let reqUrl = '/nccloud/riart/billFlow/billFlowUrlAction.do';
    if (typeof option.pathModule === 'string') {
        reqUrl = '/nccloud/' + option.pathModule + '/riart/billFlow/billFlowUrlAction.do';
    }
    let runContext = getRunContext();
    ajax({
        url: reqUrl,
        method: 'post',
        data: {
            billpk: option.billpk,
            billtypecode: option.billtype,
            pagecode: null,
            sence: '4',
        },
        async: false,
        success: result => {
            //查到以后校验
            if (result.success && result.data && result.data.appPageVO) {
                let url = '';
                if (result.data.appPageVO.pageurl) {
                    url = result.data.appPageVO.pageurl.replace('nccloud/resources/', '');
                }
                let newUrl = getResPageUrl(url, {
                    id: option.billpk,
                    status: 'browse',
                    scene: 'linksce',
                });

                let oldWinHash = '';
                if (getParentWindow(window) === getTopWindow() && CONFIG.isPageModal) {
                    let oldUrl = getAppUrl(undefined, runContext).pageurl;
                    oldWinHash = CONFIG.isRemoveWorkbench ? oldUrl : (oldUrl.includes('?') ? oldUrl : ('?' + oldUrl));
                } else {
                    oldWinHash = getLocation(getParentWindow(window)).hash;
                }
                let openCheck = CONFIG.isRemoveWorkbench ? topOpenCheck : getTopWindow().openCheck || topOpenCheck;
                openCheck(
                    result.data.appcode,
                    result.data.appPageVO.pagecode,
                    (win, res, openWinCallBack) => {
                        checkCallBack({
                            win, //打开页签window
                            res, //后台返回应用信息
                            path: newUrl, // 业务传递url
                            appcode: result.data.appcode,
                            pagecode: result.data.appPageVO.pagecode,
                            type: option.type || 'link', //打开方式 'open' 'link' 'router'
                            oldWinHash, //原来的参数
                            params: {
                                id: option.billpk,
                                status: 'browse',
                                scene: 'linksce',
                            }, //业务传新参数
                            openWinCallBack,
                        });
                    },
                    (option.type && option.type === 'open') ? 'tab' : '',
                    { toastContainer: document.body },
                );
            }
        },
    });

}

/**
 * 更新面包屑导航
 * @memberof PageTo
 * @param {Object | function} option {b1:1,b2:2,b3:3,n:4} / ({b1,b2,b3,n}) => ({b1,b2,b3:3,n:4})
 */
function updateBreadcrumb(option) {
    if (getTopWindow() && typeof getTopWindow().updateBreadcrumb === 'function') {
        getTopWindow().updateBreadcrumb(option);
    }
}

function getCrossTabData() {
    let key = getUrlKey();
    let data = getTopWindow().AppCrossTabData;
    if (data?.[key]) {
        return data[key];
    }
}

let getWorkbenchParam = _getWorkbenchParam;

export {
    linkTo,
    openTo,
    pushTo,
    specialOpenTo,
    specialLinkTo,
    linkBack,
    openOut,
    addUrlParam,
    setUrlParam,
    getUrlParam,
    delUrlParam,
    getSearchParam,
    checkCallBack,
    getResPageUrl,
    getAppCode,
    getPageCode,
    getDomainCode,
    getModuleCode,
    addParentUrlParam,
    openAppByBilltype,
    specialOpenToOut,
    setPageCode,
    deleteParentUrlParam,
    updateBreadcrumb,
    getPageContext,
    setPageContext,
    getBreadCrumb,
    getTopParam,
    getUrlPathName,
    getUrlKey,
    getMainUrlKey,
    getWorkbenchParam,
    getCrossTabData,
};
